import { render } from "./ProductForm.vue?vue&type=template&id=8795ab46&scoped=true&ts=true"
import script from "./ProductForm.vue?vue&type=script&lang=ts"
export * from "./ProductForm.vue?vue&type=script&lang=ts"

import "./ProductForm.vue?vue&type=style&index=0&id=8795ab46&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8795ab46"]])

export default __exports__